import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-numeric-stepper-config-view',
  standalone: true,
  templateUrl: './numeric-stepper-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumericStepperConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
